import '@babel/polyfill';

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';
import VueTextareaAutosize from 'vue-textarea-autosize';

import ElLoading from 'element-ui/lib/loading';
import 'element-ui/lib/theme-chalk/index.css';
/* Sweetalert2 */
import Swal from 'sweetalert2';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
import Vuetify from 'vuetify';
import 'vue-croppa/dist/vue-croppa.css';
import Croppa from 'vue-croppa';
// Frontend [Jitendra.p]
import moment from 'moment';
// support Frontend Route

require('./bootstrap');
window.AOS = require('aos');
require('./script.js');
// require("signature_pad");
window.Swal = Swal;

const toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    allowOutsideClick: false,
    // width: 'auto',
});

window.toast = toast;
/* End Sweetalert2 */

Vue.use(ElLoading);
Vue.use(VueI18n);
Vue.use(VueRouter);
Vue.use(VueTextareaAutosize);

Vue.use(
    Vuetify, {
        theme: {
            primary: '#ff0095ff',
            secondary: '#ff0000ff',
            accent: '#e60000ff',
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107',
        },
    },
);

Vue.use(Croppa);

require('./mixins');

Vue.component('pagination', require('laravel-vue-pagination'));

Vue.filter('capitalize', (value) => {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.filter('cardYearFromat', (value) => {
    if (!value) return '';
    value = value.toString();
    return value.substring(2, 4);
});

Vue.filter('day', (value) => {
    if (value) {
        return moment(String(value)).format('Do');
    }
});

Vue.filter('shortMonth', (value) => {
    if (value) {
        return moment(String(value)).format('MMM');
    }
});

Vue.filter('fullMonth', (value) => {
    if (value) {
        return moment(String(value)).format('MMMM');
    }
});

Vue.filter('dayWithShortMonth', (value) => {
    if (value) {
        return moment(String(value)).format('Do MMM');
    }
});

Vue.filter('dayWithFullMonth', (value) => {
    if (value) {
        return moment(String(value)).format('Do MMMM');
    }
});

Vue.filter('formatDate', (value) => {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY');
    }
});

Vue.filter('formatDateTime', (value) => {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY hh:mm');
    }
});

const router = new VueRouter({
        mode: 'history',
        // base: makeBaseUrl(),
        routes: [],
    }),
    app = new Vue({
        el: '#app',
        router,
        data: {},
    });

// const ApiBaseUrl = 'http://leadcityesign.vlab/api';
window.axios.defaults.baseURL = 'https://signfast2.local/api';

window.axios.interceptors.response.use(null, (error) => {
    if (error.response === undefined
    ) {
        console.log(error);
        return;
    }
    if (error.response.status === 403) {
        app.$notify.error({
            title: app.$t('core.unauthorized'),
            message: app.$t('core.unauthorized-access'),
        });
        window.location = route('dashboard.index');
    }
    if (error.response.status === 401) {
        app.$notify.error({
            title: app.$t('core.unauthenticated'),
            message: app.$t('core.unauthenticated-message'),
        });
        window.location = route('login');
    }
    return Promise.reject(error);
});

if (window.__viteResolve) {
    window.__viteResolve();
}
